import { useEffect, useState } from "react";
import { CountryList } from "../../utils/countrylist";

// import { CgPacman } from "react-icons/cg";

// const CountryList = [
//     {
//         isoCode: "tg",
//         name: "TOGO",
//         code: "+228",
//         digit: 8,
//         currency: "xof",
//         payments: [],
//     },
//     {
//         isoCode: "bj",
//         name: "BENIN",
//         code: "+229",
//         digit: 8,
//         currency: "xof",
//         payments: [],
//     },
//     {
//         isoCode: "cm",
//         name: "CAMEROON",
//         code: "+237",
//         digit: 9,
//         currency: "xaf",
//         payments: [],
//     },
//     {
//         isoCode: "sn",
//         name: "SENEGAL",
//         code: "+221",
//         digit: 9,
//         currency: "xof",
//         payments: [],
//     },
//     {
//         isoCode: "bf",
//         name: "BURKINA FASO",
//         code: "+226",
//         digit: 8,
//         currency: "xof",
//         payments: [],
//     },
//     {
//         isoCode: "ci",
//         name: "COTE D'IVOIRE",
//         code: "+225",
//         digit: 10,
//         currency: "xof",
//         payments: [],
//     },
//     {
//         isoCode: "ml",
//         name: "MALI",
//         code: "+223",
//         digit: 8,
//         currency: "xof",
//         payments: [],
//     },
// ];

export const WithdrawalsContent = () => {
    const [userBasePhone, setUserBasePhone] = useState("");
    const [userBaseCode, setUserBaseCode] = useState("");
    const [userBaseCountryDetails, setUserBaseCountryDetails] = useState(null);
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));

    const [otherCountrySelected, selectOtherCountry] = useState(false);
    const [alternativeCountryDetails, setAlternativeCountryDetails] = useState(CountryList[0]);
    const [alternativePhoneNumber, setAlternativePhoneNumber] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const [amount, setAmount] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [countryList, setCountryList] = useState([]);
    const [transactionHistory, setTransactionHistory] = useState([]);
    const apiUrl = process.env.REACT_APP_CAPITALYA_API_URL;
    const minWithdrawal = 2500;
    const feePercentage = 6.5;

    // Récupération des services disponibles
    useEffect(() => {
        if (!token) return;
        // console.log(user)

        const fetchServices = async () => {
            try {
                const response = await fetch(
                    "https://express-qw8z.onrender.com/api/activation/services"
                );
                const data = await response.json();

                if (!response.ok) {
                    console.error("Erreur lors de la récupération des services");
                    return;
                }

                // console.log(data)

                const services = data.services.data.filter(
                    service => service.is_active && service.country
                );

                const updatedCountries = CountryList.map(country => ({
                    ...country,
                    payments: []
                }));

                services.forEach(service => {
                    const country = updatedCountries.find(
                        c => c.isoCode.toLowerCase() === service.country.code.toLowerCase()
                    );

                    if (country && !country.payments.includes(service.name)) {
                        country.payments.push(service.name);
                    }
                });

                setCountryList(updatedCountries);

                if (updatedCountries.length > 0) {
                    setAlternativeCountryDetails(updatedCountries[0]);
                }
            } catch (error) {
                console.error("Erreur fetch services :", error);
            }
        };

        fetchServices();
    }, [token]);

    // Récupération des infos utilisateur
    useEffect(() => {
        if (!token) return;

        const fetchUserInfos = async () => {
            try {
                const response = await fetch(
                    `${apiUrl}/api/activation/get-transaction-form-filling-infos`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                const data = await response.json();
                // console.log(data)

                if (!response.ok) {
                    console.error("Erreur : ", data.message);
                    return;
                }

                const { name, code, digit, tel, isoCode } = data.infos;

                const matchedCountry = countryList.find(
                    c => c.code === code || c.isoCode === isoCode
                );

                const finalPayments = matchedCountry?.payments || [];

                setUserBasePhone(tel);
                setUserBaseCode(code);

                setUserBaseCountryDetails({
                    name,
                    code,
                    isoCode,
                    digit,
                    payments: finalPayments
                });

                if (finalPayments.length > 0) {
                    setPaymentMethod(finalPayments[0]);
                }
            } catch (err) {
                console.error("Erreur fetch infos :", err);
            }
        };

        fetchUserInfos();
    }, [apiUrl, token, countryList]);

    //Recupérration de l'historique

    useEffect(() => {
        if (!token) return;

        const getHistory = async () => {
            try {
                const response = await fetch(
                    `${apiUrl}/api/activation/get-transaction-history`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                const data = await response.json();

                if (!response.ok) {
                    console.error("Erreur getTransactionHistory:", data.message);
                    return;
                }

                setTransactionHistory(data.transactions);
            } catch (e) {
                console.error("Erreur getTransactionHistory:", e.message);
            }
        };

        getHistory();
    }, [apiUrl, token]);


    // Synchronisation automatique du payment method
    useEffect(() => {
        if (!token) return;

        if (otherCountrySelected && alternativeCountryDetails?.payments?.length) {
            setPaymentMethod(alternativeCountryDetails.payments[0]);
        }
    }, [alternativeCountryDetails, otherCountrySelected, token]);

    const currentCountryDetails = otherCountrySelected
        ? alternativeCountryDetails
        : userBaseCountryDetails;

    const currentPhoneNumber = otherCountrySelected
        ? alternativePhoneNumber
        : userBasePhone;

    const currentCode = otherCountrySelected
        ? alternativeCountryDetails?.code
        : userBaseCode;

    const calculateFee = (amt) => {
        const numAmount = parseFloat(amt) || 0;
        return Math.round((numAmount * feePercentage) / 100);
    };

    // const calculateNetAmount = (amt) => {
    //     const numAmount = parseFloat(amt) || 0;
    //     return numAmount - calculateFee(amt);
    // };

    const handleWithdrawal = async () => {
        setErrorMessage("");
        setSuccessMessage("");

        const numAmount = parseFloat(amount);

        if (!numAmount || numAmount < minWithdrawal) {
            setErrorMessage(`Le montant minimum est de ${minWithdrawal}F`);
            return;
        }

        if (numAmount > user?.gain) {
            setErrorMessage(`Solde insuffisant.`)
        }

        if (otherCountrySelected) {
            if (!alternativePhoneNumber || alternativePhoneNumber.length !== alternativeCountryDetails.digit) {
                setErrorMessage(`Veuillez entrer un numéro de téléphone valide (${alternativeCountryDetails.digit} chiffres)`);
                return;
            }
        }

        const fullPhoneNumber = otherCountrySelected ? alternativePhoneNumber : userBasePhone;

        setIsLoading(true);
        // console.log({
        //     tel: fullPhoneNumber,
        //     paymentMethod,
        //     country: currentCountryDetails,
        //     amount: numAmount
        // });

        try {
            const response = await fetch(`${apiUrl}/api/activation/withdraw`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },

                body: JSON.stringify({
                    tel: fullPhoneNumber,
                    paymentMethod,
                    country: currentCountryDetails.name,
                    amount: numAmount,
                    isoCode: currentCountryDetails.isoCode
                }),
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Échec de la demande");

            setSuccessMessage(data.message || "Demande de retrait envoyée avec succès !");
            setAmount("");
            setAlternativePhoneNumber("");
        } catch (error) {
            setErrorMessage(error.message || "Une erreur est survenue");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="space-y-4 pb-20 px-2 sm:px-0">
            {/* MESSAGES */}
            {errorMessage && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative">
                    <strong className="font-bold">Erreur ! </strong>
                    <span className="block sm:inline">{errorMessage}</span>
                    <button
                        className="absolute top-0 bottom-0 right-0 px-4 py-3"
                        onClick={() => setErrorMessage("")}
                    >
                        <span className="text-2xl">&times;</span>
                    </button>
                </div>
            )}

            {successMessage && (
                <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative">
                    <strong className="font-bold">Succès ! </strong>
                    <span className="block sm:inline">{successMessage}</span>
                </div>
            )}

            {/* FORMULAIRE */}
            <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
                <h3 className="text-base sm:text-lg md:text-xl font-bold mb-4">
                    💸 Nouveau Retrait
                </h3>

                {/* NUMÉRO DE BASE */}
                <div className="mt-2 mb-4">
                    <fieldset>
                        <legend className="font-medium text-gray-700 mb-2 text-sm sm:text-base">
                            Numéro de téléphone :
                        </legend>

                        <div
                            className="flex gap-2 my-2"
                            onClick={() => {
                                selectOtherCountry(false);
                                if (userBaseCountryDetails) {
                                    setPaymentMethod(userBaseCountryDetails.payments[0]);
                                }
                            }}
                        >
                            <input
                                type="radio"
                                id="base"
                                name="withdraw"
                                checked={!otherCountrySelected}
                                onChange={() => {
                                    selectOtherCountry(false);
                                    if (userBaseCountryDetails) {
                                        setPaymentMethod(userBaseCountryDetails.payments[0]);
                                    }
                                }}
                                className="cursor-pointer flex-shrink-0 mt-1"
                            />
                            <label
                                htmlFor="base"
                                className="font-medium cursor-pointer text-sm sm:text-base break-all"
                            >
                                {userBaseCountryDetails
                                    ? `${userBasePhone}`
                                    : "Chargement..."}
                            </label>
                        </div>

                        {/* <div
                            className="flex gap-2"
                            onClick={() => {
                                selectOtherCountry(true);
                                setPaymentMethod(alternativeCountryDetails.payments[0]);
                            }}
                        >
                            <input
                                type="radio"
                                id="other"
                                name="withdraw"
                                checked={otherCountrySelected}
                                onChange={() => {
                                    selectOtherCountry(true);
                                    setPaymentMethod(alternativeCountryDetails.payments[0]);
                                }}
                                className="cursor-pointer flex-shrink-0 mt-1"
                            />
                            <label
                                htmlFor="other"
                                className="font-medium cursor-pointer text-sm sm:text-base"
                            >
                                Autre numéro
                            </label>
                        </div> */}
                    </fieldset>
                </div>

                {/* CHOIX DU PAYS */}
                {otherCountrySelected && (
                    <div className="mb-4">
                        <label className="block font-medium text-gray-700 mb-2 text-sm sm:text-base">
                            Pays
                        </label>
                        <select
                            value={alternativeCountryDetails?.code}
                            onChange={(e) => {
                                const selectedCountry = countryList.find(
                                    c => c.code === e.target.value
                                );

                                if (!selectedCountry) return;

                                setAlternativeCountryDetails(selectedCountry);
                                setAlternativePhoneNumber("");
                            }}
                            className="w-full px-3 py-3 md:py-2 border border-gray-300 rounded-md text-sm sm:text-base"
                        >
                            {countryList.map((country) => (
                                <option key={country.code} value={country.code}>
                                    {country.name}
                                </option>
                            ))}
                        </select>
                    </div>
                )}

                {/* NUMÉRO ALTERNATIF */}
                {otherCountrySelected && alternativeCountryDetails && (
                    <div className="mb-4">
                        <div className="flex gap-2 mb-2 flex-wrap">
                            <label
                                className="font-medium text-gray-700 w-full sm:w-20 text-sm sm:text-base"
                                htmlFor="code"
                            >
                                Indicatif
                            </label>
                            <label
                                className="font-medium text-gray-700 text-sm sm:text-base"
                                htmlFor="tel"
                            >
                                Numéro de téléphone
                            </label>
                        </div>

                        <div className="flex gap-2">
                            <input
                                id="code"
                                value={alternativeCountryDetails.code}
                                className="w-16 sm:w-20 px-2 sm:px-3 py-3 md:py-2 border border-gray-300 rounded-md bg-gray-100 text-sm sm:text-base font-medium text-center"
                                disabled
                            />

                            <input
                                id="tel"
                                type="tel"
                                maxLength={alternativeCountryDetails.digit}
                                placeholder={"x".repeat(alternativeCountryDetails.digit)}
                                value={alternativePhoneNumber}
                                onChange={(e) =>
                                    setAlternativePhoneNumber(e.target.value.replace(/\D/g, ""))
                                }
                                className="flex-1 min-w-0 px-3 py-3 md:py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                            />
                        </div>
                    </div>
                )}

                {/* MONTANT ET MÉTHODE */}
                <div className="space-y-4 mb-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Solde actuel
                        </label>
                        <input
                            disabled
                            value={(user?.gain || 0).toFixed(2)}
                            className="w-full px-3 py-3 md:py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base text-green-600"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Montant
                        </label>
                        <input
                            type="number"
                            min={minWithdrawal}
                            placeholder={`Minimum ${minWithdrawal}F`}
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            className={`${amount < minWithdrawal || amount > user?.gain ? 'text-red-500' : 'text-green-600'} w-full px-3 py-3 md:py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base`}
                        />
                        <p className={`text-xs ${amount < minWithdrawal ? 'text-red-500' : 'text-gray-600'} mt-1`}>
                            Minimum: {minWithdrawal}F - Frais: {feePercentage}%
                        </p>
                    </div>

                    {currentCountryDetails && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Méthode de paiement
                            </label>
                            <select
                                value={paymentMethod}
                                onChange={(e) => setPaymentMethod(e.target.value)}
                                className="w-full px-3 py-3 md:py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                            >
                                {currentCountryDetails.payments.map((item, key) => (
                                    <option key={key} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>

                {/* RÉCAP */}
                {amount && parseFloat(amount) >= minWithdrawal && (
                    <div className="bg-gray-50 rounded-lg p-3 sm:p-4 mb-4">
                        <h4 className="font-semibold text-gray-800 mb-3 text-sm sm:text-base">
                            📋 Récapitulatif
                        </h4>
                        <div className="space-y-2 text-xs sm:text-sm">
                            <div className="flex justify-between items-start gap-2">
                                <span className="text-gray-600">Numéro :</span>
                                <span className="font-medium text-right break-all max-w-[60%]">
                                    {(currentPhoneNumber + "").includes("+") ? "" : currentCode} {currentPhoneNumber}
                                </span>
                            </div>

                            <div className="flex justify-between items-start gap-2">
                                <span className="text-gray-600">Montant demandé :</span>
                                <span className="font-medium text-right">
                                    {parseFloat(amount).toLocaleString()} F
                                </span>
                            </div>

                            <div className="flex justify-between items-start gap-2">
                                <span className="text-gray-600">Frais ({feePercentage}%) :</span>
                                <span className="font-medium text-right text-red-600">
                                    -{calculateFee(amount).toLocaleString()} F
                                </span>
                            </div>

                            <div className="flex justify-between items-start gap-2">
                                <span className="text-gray-600">Méthode :</span>
                                <span className="font-medium text-right break-words max-w-[60%]">
                                    {paymentMethod}
                                </span>
                            </div>

                            {/* <div className="border-t pt-2 flex justify-between items-start gap-2">
                                <span className="font-bold text-gray-800">Net à recevoir :</span>
                                <span className="font-bold text-green-600 text-sm sm:text-lg text-right whitespace-nowrap">
                                    {calculateNetAmount(amount).toLocaleString()} F CFA
                                </span>
                            </div> */}
                        </div>
                    </div>
                )}

                {/* BOUTON */}
                <button
                    onClick={handleWithdrawal}
                    disabled={isLoading}
                    className={`w-full ${isLoading
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 transform hover:scale-105'
                        } text-white font-bold py-3 md:py-4 px-4 sm:px-6 rounded-lg transition-all duration-300 shadow-lg text-sm sm:text-base flex items-center justify-center gap-2`}
                >
                    {isLoading ? (
                        <>
                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                            <span>Traitement en cours...</span>
                        </>
                    ) : (
                        <>
                            <span>✅</span>
                            <span>Demander le retrait</span>
                        </>
                    )}
                </button>

                <p className="text-xs text-gray-500 text-center mt-3">
                    Votre retrait sera traité dans les plus brefs délais
                </p>
            </div>

            {/* HISTORIQUE */}
            <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
                <h3 className="text-base sm:text-lg md:text-xl font-bold mb-4">
                    📋 Historique
                </h3>

                {/* Cards mobile */}
                <div className="space-y-3 md:hidden">
                    {transactionHistory.length === 0 ? (
                        <div className="text-center text-gray-500 text-sm">
                            Aucun retrait effectué
                        </div>
                    ) : (
                        transactionHistory.map((item, key) => (
                            <div
                                key={item._id || key}
                                className="border rounded-lg p-3 bg-gray-50"
                            >
                                <div className="flex justify-between items-start mb-2">
                                    <div>
                                        <p className="font-medium text-gray-800 text-sm">
                                            {item.amount.toLocaleString()} F
                                        </p>
                                        <p className="text-xs text-gray-600">
                                            {new Date(item.createdAt).toLocaleDateString("fr-FR")}
                                        </p>
                                    </div>

                                    <span className={`${item.metadata?.payoutResponse?.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'} px-2 py-1 rounded text-xs`}>
                                        {item.metadata?.payoutResponse?.success ? 'Succès' : 'Echec'}
                                    </span>
                                </div>

                                <div className="text-xs space-y-1">
                                    <div className="flex justify-between">
                                        <span className="text-gray-600">Frais :</span>
                                        <span>
                                            {item.metadata?.fees?.total?.toLocaleString()} F
                                        </span>
                                    </div>

                                    <div className="flex justify-between">
                                        <span className="text-gray-600">Méthode :</span>
                                        <span>{item.paymentMethod}</span>
                                    </div>

                                    <div className="flex justify-between">
                                        <span className="text-gray-600">Téléphone :</span>
                                        <span>{item.tel}</span>
                                    </div>

                                    <div className="flex justify-between">
                                        <span className="text-gray-600">Pays :</span>
                                        <span>{item.country}</span>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>


                {/* Table desktop */}
                <div className="hidden md:block overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="border-b">
                                <th className="text-left py-2">Date</th>
                                <th className="text-left py-2">Montant</th>
                                <th className="text-left py-2">Frais</th>
                                <th className="text-left py-2">Méthode</th>
                                <th className="text-left py-2">Téléphone</th>
                                <th className="text-left py-2">Pays</th>
                                <th className="text-left py-2">Statut</th>
                                {/* <th className="text-left py-2">Solde</th> */}
                                {/* <th className="text-left py-2">Net reçu</th> */}
                                {/* <th className="text-left py-2">Statut</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {transactionHistory?.map((item, key) => {
                                return (
                                    <tr className="border-b" key={key}>
                                        <td className="py-2">
                                            {new Date(item.createdAt).toLocaleDateString()}
                                        </td>
                                        <td className="py-2 font-semibold">
                                            {item.amount.toLocaleString()} F
                                        </td>
                                        <td className="py-2">
                                            {item.metadata?.fees?.total?.toLocaleString()} F
                                        </td>
                                        <td className="py-2">{item.paymentMethod}</td>
                                        <td className="py-2">{item.tel}</td>
                                        <td className="py-2">{item.country}</td>
                                        <td><span className={`${item.metadata?.payoutResponse?.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'} px-2 py-1 rounded text-xs`}>
                                            {item.metadata?.payoutResponse?.success ? 'Succès' : 'Echec'}
                                        </span></td>
                                        {/* <td className="py-2">10000F</td> */}
                                        {/* <td className="py-2">
                                    <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs">
                                        Traité
                                    </span>
                                </td> */}
                                    </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};